import { m, AnimatePresence } from 'framer-motion';
import { Trash2, X, AlertCircle } from 'lucide-react';
import React from 'react';

/**
 * BulkActionBar - Premium Industrial Floating Toolbar
 * Appears when multiple items are selected in a DataGrid.
 */
const BulkActionBar = ({ 
    selectedCount = 0, 
    onClear = () => {}, 
    onDelete = () => {},
    label = "items selected" 
}) => {
    return (
        <AnimatePresence>
            {selectedCount > 0 && (
                <m.div
                    initial={{ y: 100, opacity: 0, scale: 0.9 }}
                    animate={{ y: 0, opacity: 1, scale: 1 }}
                    exit={{ y: 100, opacity: 0, scale: 0.9 }}
                    className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 w-full max-w-2xl px-4"
                >
                    <div className="bg-slate-900/90 backdrop-blur-xl border border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.5)] rounded-[2.5rem] p-3 flex items-center justify-between gap-4 ring-1 ring-white/20">
                        
                        {/* Selector Info */}
                        <div className="flex items-center gap-3 pl-3 sm:pl-6">
                            <div className="w-9 h-9 sm:w-10 sm:h-10 bg-accent text-primary-dark rounded-2xl flex items-center justify-center font-black text-base sm:text-lg shadow-lg shadow-accent/20 shrink-0">
                                {selectedCount}
                            </div>
                            <div className="flex flex-col">
                                <span className="text-[8px] sm:text-[10px] font-black uppercase tracking-[0.2em] text-white/40 leading-none mb-1">
                                    Strategic Batch
                                </span>
                                <span className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-wider">
                                    {label}
                                </span>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="flex items-center gap-1.5 pr-1.5 sm:gap-2 sm:pr-2">
                            <button
                                onClick={onClear}
                                className="flex items-center gap-1 sm:gap-2 px-3 sm:px-6 py-2 sm:py-3 text-white/60 hover:text-white font-black text-[8px] sm:text-[10px] uppercase tracking-widest transition-all hover:bg-white/5 rounded-2xl cursor-pointer"
                            >
                                <X size={16} />
                                <span className="hidden sm:inline">Cancel</span>
                            </button>

                            <button
                                onClick={onDelete}
                                className="flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-2.5 sm:py-3 bg-red-600 hover:bg-red-700 text-white font-black text-[9px] sm:text-[10px] uppercase tracking-[0.15em] sm:tracking-[0.2em] rounded-2xl transition-all shadow-xl shadow-red-600/20 active:scale-95 group shrink-0 cursor-pointer"
                            >
                                <Trash2 size={16} className="group-hover:scale-110 transition-transform" />
                                <span className="hidden sm:inline">Delete Batch</span>
                            </button>
                        </div>
                        
                        {/* Warning Indicator */}
                        <div className="absolute -top-3 -right-3">
                            <div className="bg-amber-500 text-primary-dark p-2 rounded-xl shadow-lg animate-pulse">
                                <AlertCircle size={14} strokeWidth={3} />
                            </div>
                        </div>

                    </div>
                </m.div>
            )}
        </AnimatePresence>
    );
};

export default BulkActionBar;
